<!-- Top Navigation Bar -->
<div class="top-bar">
  <div class="top-bar-content">
    <a class="logo" routerLink="/home">
      <img src="logo-ploggit.png" alt="Ploggit" />
    </a>

    <nav class="nav-menu">
      <a class="nav-link" routerLink="/home" routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: true }">{{ 'home' | translate }}</a>

      <a class="nav-link" routerLink="/conceito" routerLinkActive="active">{{ 'whatIs' | translate }}</a>

      <a class="nav-link" routerLink="/comunidade" routerLinkActive="active">{{ 'community' | translate }}</a>

      <a class="nav-link" routerLink="/parcerias" routerLinkActive="active">{{ 'partnerships' | translate }}</a>

      <ng-container *ngIf="!(user$ | async); else loggedIn">
        <a class="nav-link" routerLink="/login" routerLinkActive="active">{{ 'login' | translate }}</a>
      </ng-container>

      <ng-template #loggedIn>
        <div class="notifications-wrapper">
          <button type="button" class="nav-icon" [class.active]="showNotifications" (click)="toggleNotifications()">
            <span class="material-symbols-outlined">notifications</span>
            @if (unreadCount > 0) {
            <span class="notification-badge">{{ unreadCount }}</span>
            }
          </button>

          @if (showNotifications) {
          <div class="notifications-dropdown">
            <p class="dropdown-title">{{ 'notifications' | translate }}</p>

            @if (notifications.length > 0) {
            <div class="users-list-wrapper">
              @for (notification of notifications; track notification) {
              @if (!notification.read) {
              <div class="notification-item unread" (click)="onNotificationClick(notification)">
                <img [src]="notification.senderPhoto || 'default-avatar.png'" alt="">
                <div class="info">
                  <p class="name">{{ notification.userSenderName }}</p>
                  <p class="message-date">{{ notification.message }}</p>
                  <p class="message-date">{{ formatNotificationDate(notification.pubDate) }}</p>
                </div>
              </div>
              } @else {
              <div class="notification-item" (click)="navigateTo(notification)">
                <img [src]="notification.senderPhoto || 'default-avatar.png'" alt="">
                <div class="info">
                  <p class="name">{{ notification.userSenderName }}</p>
                  <p class="message-date">{{ notification.message }}</p>
                  <p class="message-date">{{ formatNotificationDate(notification.pubDate) }}</p>
                </div>
              </div>
              }
              }
            </div>
            } @else {
            <div class="no-notifications">{{ 'noNotifications' | translate }}</div>
            }
          </div>
          }
        </div>

        <img class="profile-pic" [src]="userProfileUrl || 'default-avatar.png'" alt="Profile"
          (click)="navigateToProfilePersonalInfo()" />

        <button type="button" class="nav-icon" (click)="openLogOutPopup()">
          <span class="material-symbols-outlined">logout</span>
        </button>

        <app-popup [show]="showLogoutPopup" title="logout" message="popup_logout" (close)="closePopup()"
          (confirm)="confirmLogout()" [globalPopup]="true">
        </app-popup>
      </ng-template>

      <app-language-selector></app-language-selector>

      <a class="btn btn-primary" routerLink="/home" fragment="baixar">{{ 'downloadApp' | translate }}</a>
    </nav>
  </div>
</div>
